import {ActionMenu} from '#/components/actionmenu/action-menu';
import {Header} from '#/components/header/header';
import {UIStatusContext} from '#/contexts/ui-status-provider';
import {AnimatePresence} from 'framer-motion';
import {FunctionComponent, PropsWithChildren, ReactNode, useContext} from 'react';
import {Meta} from 'react-head';
import {Land, UnlistedLand} from 'shareland-common';

type LayoutProps = {
  bgColor?: `bg-${string}`;
  variant: 'fill' | 'sticky';
  onSearch: (land: Land | UnlistedLand) => void;
};

export const Layout: FunctionComponent<PropsWithChildren<LayoutProps>> = ({children, onSearch, variant, bgColor}) => {
  const {isActionMenuOpen: showActionMenu} = useContext(UIStatusContext);

  return (
    <HeaderContentLayout>
      <Meta name='theme-color' content='#1F2937' />
      <Header onSearch={onSearch} />

      <main className={`w-full h-full overflow-hidden lg:relative ${bgColor} ${variant === 'fill' ? 'lg:flex' : ''}`}>
        <div className='w-full h-full relative overflow-y-scroll'>{children}</div>

        <AnimatePresence>
          {showActionMenu && (
            <div
              className={
                "w-full h-full p-0 lg:p-4 lg:pl-0 lg:w-actionMenuWidth absolute top-0 right-0 z-10 data-[variant='fill']:lg:relative data-[variant='fill']:lg:grow-0 data-[variant='fill']:lg:shrink-0"
              }
              data-variant={variant}
            >
              <ActionMenu />
            </div>
          )}
        </AnimatePresence>
      </main>
    </HeaderContentLayout>
  );
};

export const HeaderContentLayout: FunctionComponent<{children: ReactNode[]; className?: string}> = ({
  children,
  className,
}) => {
  return (
    <div className={`h-full w-full relative grid grid-rows-headerContent overflow-hidden ${className}`}>{children}</div>
  );
};
